import { useEffect } from "react";
import { usePartnerInfo } from "../usePartnerInfoContext";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { InfoMessageType } from "src/SharedComponents/InfoBar/InfoBar";
import { useGetClinicCountries } from "./useGetClinicCountries";

export const useGetClinicCountriesWrapper = () => {
    const {countries, loading, error } = useGetClinicCountries();
    const { setInfobar, setLoader, reset } = usePartnerInfo();
    useEffect(() => {
        if (error) {
            logger.logError(`Failed to fetch countries.`)
            setInfobar({message: error, messageType: InfoMessageType.error});
        }
    }, [error, setInfobar])

    useEffect(()=> {
        setLoader(loading);
    }, [loading, setLoader])

    useEffect(() => {
        reset();
    },[reset])

    return {countries}
}